<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <ng-container *ngIf="tools">
            <app-tree [isMaterial]="false"
                      emptyMessage="{{'admin.lifts.batches.noToolsSelected' | translate}}"
                      [(items)]="treeDisplayTools"
            ></app-tree>
        </ng-container>
    </div>
    <div class="modal-footer" modal-footer>
        <div [formGroup]="cartForm">
            <app-input
                formControlName="name"
                type="number"
                [formControl]="cartForm.controls.name"
                [showErrors]="showValidations"
                [label]="'admin.lifts.batches.cartNumberLabel' | translate"
                [placeholder]="'admin.lifts.batches.cartNumberLabel' | translate">
            </app-input>
        </div>
        <app-button *ngIf="areToolsSelected"
                    type="primary"
                    class="create"
                    [disabled]="isLoading"
                    (click)="updateCartClick()">
            {{ 'generic.buttons.save' | translate }}
        </app-button>
    </div>
</app-modal>
